import { render, staticRenderFns } from "./ManagementReports.vue?vue&type=template&id=432a21bf&"
import script from "./ManagementReports.vue?vue&type=script&lang=js&"
export * from "./ManagementReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports